import { Parser } from "json2csv";
import { toast } from "react-toastify";

/**
 * Exports current page location data to CSV
 * @param {Array} locations - Array of location data from current page
 */
export const handleExportLocationsCSV = (locations) => {
  if (locations.length === 0) {
    toast.error("No data available to export");
    return;
  }
  const fields = [
    "id",
    "name",
    "address",
    "phone",
    "status",
  ];
  const opts = { fields };
  const parser = new Parser(opts);
  const csv = parser.parse(locations);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "locations.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  toast.success("CSV file exported successfully!");
};

/**
 * Fetches all locations from API and exports to CSV
 * @param {Object} axiosInstance - Configured axios instance with authentication
 * @param {string} locationName - Optional location name to filter by
 * @param {string} status - Optional status to filter by
 */
export const handleExportLocationsCSVWithFetch = async (axiosInstance, locationName = "", status = "") => {
  try {
    const params = { per_page: 10000 };
    
    if (locationName && locationName.trim()) {
      params.name = locationName.trim();
    }
    
    if (status) {
      params.status = status;
    }
    
    const response = await axiosInstance.get("/super-admin/locations", { params });
    const locationsData = response.data?.data?.data || [];
    if (locationsData.length === 0) {
      toast.error("No data available to export");
      return;
    }
    const fields = [
      "id",
      "name",
      "address",
      "phone",
      "status",
    ];
    const opts = { fields };
    const parser = new Parser(opts);
    const csv = parser.parse(locationsData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "locations.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    toast.success("All locations CSV file exported successfully!");
  } catch (error) {
    console.error("Error fetching locations or exporting CSV:", error);
    toast.error("An error occurred while exporting the data.");
  }
};
